import { render, staticRenderFns } from "./WorksRecords.vue?vue&type=template&id=0cd4e241&"
import script from "./WorksRecords.vue?vue&type=script&lang=js&"
export * from "./WorksRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports